export default {
      id: "ntp-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#ntp",
      toString: function () {
        return this.url;
      }
    }